<mat-card>
  <mat-card-content>
    <mat-card-title>
     Utenti
    </mat-card-title>
    <div fxLayout="row wrap">
      <div fxFlex="15%;" fxFlex.xs="100%">
        <mat-form-field class="full-width">
          <mat-select [(ngModel)]="txtisVerificato" id="isVerificato">
            <mat-option value="1">Verificati</mat-option>
            <mat-option value="0">Non verificati</mat-option>
            <mat-option value="-1">Tutti</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      &nbsp;&nbsp;
      <div fxFlex="20%;" fxFlex.xs="100%">
        <mat-form-field class="full-width">
          <input [(ngModel)]="txtCognome" id="Cognome" matInput placeholder="Cognome">
        </mat-form-field>
      </div>
      &nbsp;&nbsp;
      <div fxFlex="15%;" fxFlex.xs="100%">
        <mat-form-field class="full-width">
          <input [(ngModel)]="txtNome" id="Nome" matInput placeholder="Nome">
        </mat-form-field>
      </div>
      &nbsp;&nbsp;
      <div fxFlex="20%;" fxFlex.xs="100%">
        <mat-form-field class="full-width">
          <input [(ngModel)]="txtEmail" id="Email" matInput placeholder="Email">
        </mat-form-field>
      </div>
      &nbsp;&nbsp;
      <div fxFlex="20%" fxFlex.xs="100%">
        <mat-form-field class="full-width">
          <input [(ngModel)]="txtCodiceFiscale" id="CodiceFiscale" matInput placeholder="Codice Fiscale">
        </mat-form-field>
      </div>
    </div>
   
    <div class="row">
      <div fxFlex="50%;" fxFlex.xs="100%">
        <mat-form-field class="full-width">
          <mat-select placeholder="Ateneo" [(ngModel)]="txtAteneo" (selectionChange)="getDipartimenti($event.value)"
                      id="idAteneo">
            <mat-option></mat-option>
            <mat-option *ngFor="let obj of lstElencoAteneo" [value]="obj.idAteneo">
              {{obj.Ateneo}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      &nbsp;&nbsp;
      <div fxFlex="40%;" fxFlex.xs="100%">
        <mat-form-field>
          <mat-select [(ngModel)]="txtDipartimento" placeholder="Dipartimento" id="idAteneo">
            <mat-option *ngFor="let obj of lstElencoDipartimento" [value]="obj.idAteneo">
              {{obj.Dipartimento}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!--   <div fxFlex="50%;" fxFlex.xs="100%">
    <mat-form-field class="full-width">
      <mat-select placeholder="Ateneo" [(ngModel)]="txtAteneo"
                  id="idAteneo">
        <mat-option></mat-option>
        <mat-option *ngFor="let obj of lstAtenei" [value]="obj.idAteneo">
          {{obj.Ateneo}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div> -->
      <div fxFlex="10%;" fxFlex.xs="100%">
        <button mat-raised-button
                color="primary"
                (click)="btnCerca()">
          Cerca
        </button>
      </div>

       <div fxFlex="10%;" fxFlex.xs="100%">
    <button mat-raised-button
            color="primary"
            (click)="btnAggiungiModifica(-1)">
      Nuovo
    </button>
  </div>

  <div fxFlex="10%;" fxFlex.xs="100%">
    <button mat-raised-button color="primary">
      <a style="color:white" csvLink delimiter=";" [data]="lstElenco" filename="Utenti">Esporta CSV</a>
    </button>
  </div> 

    </div>



  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>

    <div fxLayout="row wrap">
      <div fxFlex.gt-sm="50%">
        <mat-form-field class="full-width">
          <input matInput
                 placeholder="Filtra"
                 [(ngModel)]="txtFiltra"
                 id="txtFiltra"
                 value=""
                 (keyup)='updateFilter($event)'>
        </mat-form-field>
      </div>
    </div>

    <ngx-datatable #grdUtenti
                   [rows]="lstElenco"
                   [columnMode]="'flex'"
                   [headerHeight]="50"
                   [footerHeight]="50"
                   [limit]="30"
                   [rowHeight]="'auto'">

      <ngx-datatable-column name="" [flexGrow]="0.5">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div style="float:left">
            <button mat-icon-button mat-sm-button color="primary"
                    class="mr-1"
                    (click)="btnAggiungiModifica(row.idUtentiProfilo)"
                    matTooltip="Modifica">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Cognome"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="Cognome">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.Cognome }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Nome"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="Nome">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.Nome }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Email"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="Email">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.Email }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Ateneo"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="Ateneo">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.Ateneo }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Dipartimento"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="Dipartimento">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.Dipartimento }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Codice Fiscale"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="CodiceFiscale">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.CodiceFiscale }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Verificato"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="isVerificato">
        <ng-template let-row="row" ngx-datatable-cell-template>

          <span *ngIf="row?.isVerificato == 0">
            <button mat-icon-button style="color:red" (click)="btnVerificaUtente(row.idUtentiProfilo)">
              <mat-icon>close</mat-icon>
            </button>
            {{ row?.isVerificato === 1 ? 'Si' : 'No'}}
          </span>

          <span *ngIf="row?.isVerificato == 1">
            <mat-icon style="color:green">done</mat-icon>
            {{ row?.isVerificato === 1 ? 'Si' : 'No'}}
          </span>

        </ng-template>
      </ngx-datatable-column>

    </ngx-datatable>

  </mat-card-content>
</mat-card>

